import React from 'react'

import { useHistory } from 'react-router-dom'

import queryString from 'query-string'

import { Modal, Button, Row, Col } from '_zari/core'

import { CodigosTransaccionesConstant, TiposSocioConstant } from 'constants/index'

const ClienteProveedorModal = ({ handleClose, show, origen }) => {
  const history = useHistory()

  const clickLink = React.useCallback(
    tipoSocio => {
      const queryParams = queryString.stringify({
        origen: origen,
        tipoSocio: tipoSocio
      })

      history.push(`/${CodigosTransaccionesConstant.ASIENTOSCONTABLES_NUEVOOGCANJE}?${queryParams}`)
    },
    [history, origen]
  )

  return (
    <Modal show={show} size='sm'>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <Button color='primary' tiny onClick={() => clickLink(TiposSocioConstant.CLIENTE)} block>
              Cliente
            </Button>
          </Col>
          <Col md={6}>
            <Button color='primary' tiny onClick={() => clickLink(TiposSocioConstant.PROVEEDOR)} block>
              Proveedor
            </Button>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose} outline>
          Cancelar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(ClienteProveedorModal)
